import { environment } from 'environments/environment';
import { MOCK_AUTH_PATH_PREFIXES, isUiOnlyPhase, resolveMockApiConfig } from './mock-api.config';
import { UI_ONLY_PRODUCT_MODULES } from './ui-only-phase';

const MODULE_SEGMENT = /\/api\/[^/]+\/[^/]+\/([a-z0-9_]+)\//i;

export function extractApiModuleCode(url: string): string | null {
    const m = url.match(MODULE_SEGMENT);
    return m ? m[1].toLowerCase() : null;
}

export function isAuthOrSharedApiPath(url: string): boolean {
    return MOCK_AUTH_PATH_PREFIXES.some((p) => url.includes(p));
}

export function shouldMockRequest(url: string): boolean {
    if (!url.includes('/api/')) {
        return false;
    }
    if (url.includes('/api/profile/') && isUiOnlyPhase()) {
        return true;
    }
    if (url.includes('/api/campaign') && isUiOnlyPhase()) {
        return true;
    }
    if (url.includes('/api/common/') && isUiOnlyPhase()) {
        return true;
    }
    if (isAuthOrSharedApiPath(url)) {
        return false;
    }
    const moduleCode = extractApiModuleCode(url);
    if (!moduleCode) {
        return false;
    }
    if (isUiOnlyPhase()) {
        return (UI_ONLY_PRODUCT_MODULES as readonly string[]).includes(moduleCode);
    }
    const cfg = resolveMockApiConfig(environment.production, environment.mockApi);
    if (!cfg.enabled) {
        return false;
    }
    if (cfg.liveModules?.includes(moduleCode)) {
        return false;
    }
    if (cfg.mockModules?.length) {
        return cfg.mockModules.includes(moduleCode as any);
    }
    return false;
}
